// @ts-nocheck
(function () {
  'use strict';

  window.AIFlorist = window.AIFlorist || {};

  var OPTIN_KEY = 'aiflorist_marketing_opted_in';
  var PROMPT_STATE_KEY = 'aiflorist_marketing_prompt_state';
  var PROMPT_DECLINE_COUNT_KEY = 'aiflorist_marketing_decline_count';
  var TEASER_COOLDOWN_UNTIL_KEY = 'aiflorist_marketing_teaser_cooldown_until';
  var PROMPT_STATE_OPTED_IN = 'opted_in';
  var PROMPT_STATE_DECLINED = 'declined';
  var TEASER_COOLDOWN_MS = 24 * 60 * 60 * 1000;

  var promptActive = false;
  var activeTeaserEl = null;

  function shouldPromptAfterFirstUserMessage(args) {
    if (promptActive) return false;
    if (localStorage.getItem(OPTIN_KEY) === 'yes') return false;

    var state = localStorage.getItem(PROMPT_STATE_KEY);
    if (state === PROMPT_STATE_OPTED_IN || state === PROMPT_STATE_DECLINED) return false;

    if (args && args.conversationId) return false;
    return true;
  }

  function initTeaser(args) {
    if (localStorage.getItem(OPTIN_KEY) === 'yes') {
      hideTeaser();
      return;
    }
    if (isTeaserCooldownActive()) {
      hideTeaser();
      return;
    }
    var state = localStorage.getItem(PROMPT_STATE_KEY);
    if (state === PROMPT_STATE_DECLINED) {
      showTeaser(args);
      return;
    }
    hideTeaser();
  }

  function promptAfterFirstUserMessage(args) {
    if (promptActive) {
      if (args && typeof args.onContinue === 'function') args.onContinue();
      return;
    }
    var messagesEl = args && args.messagesEl;
    if (!messagesEl) {
      if (args && typeof args.onContinue === 'function') args.onContinue();
      return;
    }

    hideTeaser();
    promptActive = true;
    var continueOnce = once(function () {
      promptActive = false;
      if (args && typeof args.onContinue === 'function') args.onContinue();
    });

    var prefill = resolvePrefillProfile(args && args.identity);
    var wrapper = buildPromptWrapper(prefill);
    messagesEl.appendChild(wrapper);
    messagesEl.scrollTop = messagesEl.scrollHeight;

    var form = wrapper.querySelector('.afc-marketing-block-form');
    var firstNameEl = wrapper.querySelector('.afc-marketing-block-input--first');
    var lastNameEl = wrapper.querySelector('.afc-marketing-block-input--last');
    var emailEl = wrapper.querySelector('.afc-marketing-block-input--email');
    var submitEl = wrapper.querySelector('.afc-marketing-block-submit');
    var msgEl = wrapper.querySelector('.afc-marketing-block-msg');
    var skipEl = wrapper.querySelector('.afc-marketing-block-skip');

    if (!form || !firstNameEl || !lastNameEl || !emailEl || !submitEl || !msgEl || !skipEl) {
      continueOnce();
      return;
    }

    var submitting = false;
    function syncSubmitState() {
      if (submitting) {
        submitEl.disabled = true;
        return;
      }
      var firstName = String(firstNameEl.value || '').trim();
      var email = String(emailEl.value || '').trim().toLowerCase();
      submitEl.disabled = !(firstName && isValidEmail(email));
    }

    firstNameEl.addEventListener('input', syncSubmitState);
    emailEl.addEventListener('input', syncSubmitState);
    syncSubmitState();

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      var firstName = String(firstNameEl.value || '').trim();
      var lastName = String(lastNameEl.value || '').trim();
      var email = String(emailEl.value || '').trim().toLowerCase();
      if (!firstName) {
        setMessage(msgEl, 'Please enter your first name.', false);
        return;
      }
      if (!isValidEmail(email)) {
        setMessage(msgEl, 'Please enter a valid email.', false);
        return;
      }

      submitting = true;
      submitEl.disabled = true;
      skipEl.disabled = true;
      setMessage(msgEl, 'Saving your 10% welcome offer...', true);

      try {
        var response = await requestOptIn(args, {
          email: email,
          firstName: firstName,
          lastName: lastName,
        });
        if (!response.success) {
          throw new Error(response.error || 'Could not subscribe right now.');
        }

        localStorage.setItem(OPTIN_KEY, 'yes');
        localStorage.setItem(PROMPT_STATE_KEY, PROMPT_STATE_OPTED_IN);
        localStorage.removeItem(PROMPT_DECLINE_COUNT_KEY);
        localStorage.removeItem(TEASER_COOLDOWN_UNTIL_KEY);
        hideTeaser();
        if (args.identity && args.identity.setAnonymousProfile) {
          args.identity.setAnonymousProfile({
            email: email,
            firstName: firstName,
            lastName: lastName,
          });
        } else if (args.identity && args.identity.setAnonymousEmail) {
          args.identity.setAnonymousEmail(email);
        }
        if (typeof args.onSubscribed === 'function') {
          args.onSubscribed({
            email: email,
            firstName: firstName,
            lastName: lastName,
          });
        }

        setMessage(
          msgEl,
          response.message || 'Done. Your welcome email is on the way.',
          true
        );
      } catch (error) {
        setMessage(
          msgEl,
          (error && error.message) || 'Could not subscribe now. Continuing chat.',
          false
        );
      } finally {
        lockPrompt(wrapper);
        continueOnce();
      }
    });

    skipEl.addEventListener('click', function () {
      localStorage.setItem(PROMPT_STATE_KEY, PROMPT_STATE_DECLINED);
      var nextDeclineCount = incrementDeclineCount();
      setMessage(msgEl, 'No problem. Continuing with your bouquet now.', true);
      lockPrompt(wrapper);
      if (nextDeclineCount >= 2) {
        setTeaserCooldown(Date.now() + TEASER_COOLDOWN_MS);
        hideTeaser();
      } else {
        showTeaser(args);
      }
      continueOnce();
    });
  }

  async function requestOptIn(args, profile) {
    var customerIdentity = args.getCustomerIdentity ? args.getCustomerIdentity() : null;
    var payload = {
      email: profile.email,
      firstName: profile.firstName,
      ...(profile.lastName ? { lastName: profile.lastName } : {}),
      consent: true,
      source: 'fleur_chat_panel',
      locale: args.localeContext ? args.localeContext.locale : undefined,
      language: args.localeContext ? args.localeContext.language : undefined,
      customer: customerIdentity || undefined,
    };

    var request = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    };

    var endpoint = args.workerUrl + '/marketing/welcome-optin';
    var response = args.apiFetch
      ? await args.apiFetch(endpoint, request)
      : await fetch(endpoint, request);

    var data = {};
    try {
      data = await response.json();
    } catch (_error) {
      data = {};
    }

    if (!response.ok) {
      return {
        success: false,
        error: data && data.error ? data.error : 'Could not subscribe right now.',
      };
    }
    return Object.assign({ success: true }, data);
  }

  function buildPromptWrapper(prefill) {
    var wrapper = document.createElement('div');
    wrapper.className = 'afc-msg afc-msg--assistant afc-msg--marketing-gate';
    wrapper.innerHTML =
      '<div class="afc-bubble afc-bubble--assistant">' +
        '<section class="afc-marketing-block">' +
          '<p class="afc-marketing-block-lead">Working my magic now... ✨<br />While I finalize the details, shall I send a 10% discount code to your inbox for your first purchase?</p>' +
          '<form class="afc-marketing-block-form">' +
            '<div class="afc-marketing-block-name-row">' +
              '<input class="afc-marketing-block-input afc-marketing-block-input--first" type="text" placeholder="First name" required value="' + escapeAttr(prefill.firstName) + '" />' +
              '<input class="afc-marketing-block-input afc-marketing-block-input--last" type="text" placeholder="Last name (optional)" value="' + escapeAttr(prefill.lastName) + '" />' +
            '</div>' +
            '<input class="afc-marketing-block-input afc-marketing-block-input--email" type="email" placeholder="Enter your email..." required value="' + escapeAttr(prefill.email) + '" />' +
            '<button class="afc-marketing-block-submit" type="submit">Yes, send me the code!</button>' +
            '<p class="afc-marketing-block-msg"></p>' +
          '</form>' +
          '<button class="afc-marketing-block-skip" type="button">No thanks</button>' +
        '</section>' +
      '</div>';
    return wrapper;
  }

  function resolvePrefillProfile(identity) {
    var email = '';
    var firstName = '';
    var lastName = '';

    if (identity && identity.state) {
      email = String(identity.state.customerEmail || '').trim().toLowerCase();
      firstName = String(identity.state.marketingFirstName || '').trim();
      lastName = String(identity.state.marketingLastName || '').trim();
      if (!firstName && !lastName && identity.state.customerName) {
        var split = splitName(identity.state.customerName);
        firstName = split.firstName;
        lastName = split.lastName;
      }
    }

    var emailKey = identity && identity.MARKETING_EMAIL_KEY
      ? identity.MARKETING_EMAIL_KEY
      : 'aiflorist_marketing_email';
    var firstNameKey = identity && identity.MARKETING_FIRST_NAME_KEY
      ? identity.MARKETING_FIRST_NAME_KEY
      : 'aiflorist_marketing_first_name';
    var lastNameKey = identity && identity.MARKETING_LAST_NAME_KEY
      ? identity.MARKETING_LAST_NAME_KEY
      : 'aiflorist_marketing_last_name';

    if (!email) email = String(localStorage.getItem(emailKey) || '').trim().toLowerCase();
    if (!firstName) firstName = String(localStorage.getItem(firstNameKey) || '').trim();
    if (!lastName) lastName = String(localStorage.getItem(lastNameKey) || '').trim();

    return {
      email: email,
      firstName: firstName,
      lastName: lastName,
    };
  }

  function splitName(rawName) {
    var cleaned = String(rawName || '').trim().replace(/\s+/g, ' ');
    if (!cleaned) return { firstName: '', lastName: '' };
    var parts = cleaned.split(' ');
    if (parts.length === 1) return { firstName: parts[0], lastName: '' };
    return {
      firstName: parts.shift() || '',
      lastName: parts.join(' '),
    };
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || '').trim());
  }

  function setMessage(targetEl, text, neutral) {
    targetEl.textContent = text;
    targetEl.classList.toggle('afc-marketing-block-msg--error', !neutral);
  }

  function lockPrompt(wrapper) {
    var submitEl = wrapper.querySelector('.afc-marketing-block-submit');
    var skipEl = wrapper.querySelector('.afc-marketing-block-skip');
    var inputEls = wrapper.querySelectorAll('.afc-marketing-block-input');
    if (submitEl) submitEl.disabled = true;
    if (skipEl) skipEl.disabled = true;
    if (inputEls && inputEls.length) {
      for (var i = 0; i < inputEls.length; i++) {
        inputEls[i].disabled = true;
      }
    }
  }

  function showTeaser(args) {
    if (localStorage.getItem(OPTIN_KEY) === 'yes') {
      hideTeaser();
      return;
    }
    if (isTeaserCooldownActive()) {
      hideTeaser();
      return;
    }
    var placement = resolveTeaserPlacement(args);
    if (!placement || !placement.hostEl) return;
    var hostEl = placement.hostEl;
    if (activeTeaserEl && activeTeaserEl.isConnected) return;

    var teaser = document.createElement('button');
    teaser.type = 'button';
    teaser.className = 'afc-marketing-teaser';
    teaser.setAttribute('aria-label', 'Unlock 10% welcome offer');
    teaser.setAttribute('title', 'Unlock 10% welcome offer');
    teaser.innerHTML =
      '<span class="afc-marketing-teaser-inner">' +
        '<span class="afc-marketing-teaser-label">10%<br />OFF!</span>' +
        '<span class="afc-marketing-teaser-spark">✨</span>' +
      '</span>';
    if (placement.bottomPx !== null) {
      teaser.style.bottom = String(placement.bottomPx) + 'px';
    }

    teaser.addEventListener('click', function () {
      hideTeaser();
      promptAfterFirstUserMessage(
        Object.assign({}, args || {}, {
          onContinue: function () {},
        })
      );
    });

    hostEl.appendChild(teaser);
    activeTeaserEl = teaser;
  }

  function hideTeaser() {
    if (activeTeaserEl && activeTeaserEl.isConnected) {
      activeTeaserEl.remove();
    }
    activeTeaserEl = null;
  }

  function resolveTeaserPlacement(args) {
    var panelEl = null;
    if (args && args.panelEl) {
      panelEl = args.panelEl;
    } else if (args && args.messagesEl && typeof args.messagesEl.closest === 'function') {
      panelEl = args.messagesEl.closest('.afc');
    }
    if (!panelEl) return null;

    var bottomPx = null;
    if (typeof panelEl.querySelector === 'function') {
      var footerEl = panelEl.querySelector('.afc-input-area');
      if (footerEl && footerEl.offsetHeight) {
        bottomPx = Math.max(0, footerEl.offsetHeight - 1);
      }
    }

    return {
      hostEl: panelEl,
      bottomPx: bottomPx,
    };
  }

  function getDeclineCount() {
    var raw = String(localStorage.getItem(PROMPT_DECLINE_COUNT_KEY) || '').trim();
    var parsed = Number(raw);
    if (!Number.isFinite(parsed) || parsed < 0) return 0;
    return Math.floor(parsed);
  }

  function incrementDeclineCount() {
    var next = getDeclineCount() + 1;
    localStorage.setItem(PROMPT_DECLINE_COUNT_KEY, String(next));
    return next;
  }

  function setTeaserCooldown(timestampMs) {
    localStorage.setItem(TEASER_COOLDOWN_UNTIL_KEY, String(Math.floor(timestampMs)));
  }

  function isTeaserCooldownActive() {
    var raw = String(localStorage.getItem(TEASER_COOLDOWN_UNTIL_KEY) || '').trim();
    if (!raw) return false;
    var cooldownUntil = Number(raw);
    if (!Number.isFinite(cooldownUntil) || cooldownUntil <= 0) {
      localStorage.removeItem(TEASER_COOLDOWN_UNTIL_KEY);
      return false;
    }
    if (Date.now() >= cooldownUntil) {
      localStorage.removeItem(TEASER_COOLDOWN_UNTIL_KEY);
      return false;
    }
    return true;
  }

  function once(fn) {
    var done = false;
    return function () {
      if (done) return;
      done = true;
      fn();
    };
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function escapeAttr(value) {
    return escapeHtml(value).replace(/`/g, '&#96;');
  }

  window.AIFlorist.marketing = {
    OPTIN_KEY: OPTIN_KEY,
    PROMPT_STATE_KEY: PROMPT_STATE_KEY,
    shouldPromptAfterFirstUserMessage: shouldPromptAfterFirstUserMessage,
    initTeaser: initTeaser,
    promptAfterFirstUserMessage: promptAfterFirstUserMessage,
  };
})();
